import React from "react";

export default function FooterSmall(props) {
  return (
    <>
      <footer
        className={
          (props.absolute
            ? "absolute w-full bottom-0 bg-gray-900"
            : "relative  bottom-0 bg-gray-900") + " py-6"
        }
      >
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap items-center md:justify-between justify-center">
            <div className="w-full md:w-4/12 px-4">
              <div className="text-sm text-white  py-1">
                Copyright © {new Date().getFullYear()}{" "}
                <a
                  href="https://www.rapyuta-robotics.com"
                  className="text-white hover:text-gray-400 text-sm  py-1"
                >
                  Rapyuta Robotics
                </a>
              </div>
            </div>
            <div className="w-full md:w-8/12 px-4">
              <ul className="flex flex-wrap list-none md:justify-end  justify-center">
                <li>
                  <a
                    href="https://www.rapyuta-robotics.com"
                    className="text-white hover:text-gray-400 text-sm  block py-1 px-3"
                  >
                    Rapyuta Robotics
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.rapyuta-robotics.com/about-us/"
                    className="text-white hover:text-gray-400 text-sm  block py-1 px-3"
                  >
                    About Us
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.rapyuta-robotics.com/blog/"
                    className="text-white hover:text-gray-400 text-sm  block py-1 px-3"
                  >
                    Blog
                  </a>
                </li>
                <li>
                  <a
                    href="https://userdocs.rapyuta.io/"
                    className="text-white hover:text-gray-400 text-sm  block py-1 px-3"
                  >
                    Documentation
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}